module.exports = __webpack_public_path__ + "img/spencer-krips-bio.46112535.png";